jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
});
// todo
setTimeout(function () {
  const links = document.querySelectorAll(".sidebar-links .sidebar-link");
  const currentUrl = window.location.href;
  if (currentUrl.includes("store.hollyland.com/collections/")) {
    links.forEach((link) => {
      if (link.href === currentUrl) {
        link.classList.add("active");
      }
    });
  }
}, 1500);
